import { useMutation } from "react-query";
import api from "../api";

type TGetEmailsTeamIDResponse = {
  email: string;
  team_id: number | null;
  // Populated only for emails that belong to a team the caller is also in
  // (see the backend `users-team` enrichment) — lets a caller move an existing
  // member by id in one batched lookup. Null/absent for outsiders & other teams.
  user_id?: number | null;
  template_id?: number | null;
}[];

const getEmailsTeamID = async (
  emails: string[],
): Promise<TGetEmailsTeamIDResponse> => {
  const response = await api.post("/profile/teams/users-team", {
    emails,
  });
  return response.data;
};

export function useGetEmailsTeamID() {
  const [mutate, rest] = useMutation(getEmailsTeamID);

  return {
    getEmailsTeamID: mutate,
    ...rest,
  };
}
